import { render, staticRenderFns } from "./hit_votes.vue?vue&type=template&id=5d4d09b2&"
import script from "./hit_votes.vue?vue&type=script&lang=js&"
export * from "./hit_votes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports